import {imgPath} from "@/utils/commonData";
const getters = {
  token: state => state.user.token,
  name: state => state.user.name,
  userInfo: state => state.user.userInfo,
  userName: state => {
    return (state.user.userInfo.trueName !== null ? state.user.userInfo.trueName :
        state.user.userInfo.phone !=null ? state.user.userInfo.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'):'')
  },
  userAvatar: state => {
    return state.user.userInfo.photoPath !== null ? imgPath + state.user.userInfo.photoPath : require('@/assets/images/user.png')
  },
  isCertified: state => state.user.isCertified,
  coupon: state => state.user.coupon,
  loginStatus: state => state.common.loginStatus,
  accountType: state => {
    function bubbleSort(arr) {
      let len = arr.length;
      for (let i = 0; i < len - 1; i++) {
        for (let j = 0; j < len - i - 1; j++) {
          if (arr[j].endTime > arr[j + 1].endTime) {
            let temp = arr[j].endTime;
            arr[j].endTime = arr[j + 1].endTime;
            arr[j + 1].endTime = temp.endTime;
          }
        }
      }
      return arr;
    }
    let arr = (state.user.userInfo.memberList || []).reduce((prev,im,index)=>{
      im.endTime = new Date(im.endTime).getTime()
      prev.push(im)
      return prev
    },[])
    return bubbleSort(arr)
  }
}

export default getters
